// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App'
// import i18n from './lang'
/* 路由 */
import router from './router'
import {i18n, loadLanguageAsync} from './setup/i18n-setup'
/* logger */
import logger from './log'
Vue.prototype.logger = logger;

/* axios */
import axios from './api'
import api from './api/api'
Vue.prototype.api = api;
Vue.prototype.http = axios;

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'
import Vuetify from 'vuetify'
Vue.use(Vuetify)

const vuetify = new Vuetify({})
 
/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name, Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name, Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name, GoTop)
Vue.prototype.console = console
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title
    }
    const lang = to.params.lang? to.params.lang: "en-US"
    loadLanguageAsync(lang).then(() => next())
    // next()
});


new Vue({
  el: '#app',
  i18n,
  router,
  vuetify,
  components: { App },
  template: '<App/>'
})

// 热更新
// if (module.hot) {
//   module.hot.accept(['./lang/locale/en-US', './lang/locale/zh-CN'], function () {
//     i18n.setLocaleMessage('en-US', require('./lang/locale/en-US').default)
//     i18n.setLocaleMessage('cn-ZH', require('./lang/locale/cn-ZH').default)
//     // 同样可以通过 $i18n 属性进行热更新
//     // app.$i18n.setLocaleMessage('en', require('./en').default)
//     // app.$i18n.setLocaleMessage('ja', require('./ja').default)
//   })
// }


// WEBPACK FOOTER //
// ./src/main.js